/**
 * [we] Wine Offer – cookie helpers, form logic, collection selection mode
 */
(function () {
  'use strict';

  var COOKIE_NAME = 'we_wine_offer';
  var COOKIE_DAYS = 7;
  var BODY_CLASS = 'we-wine-offer-selecting';
  var SELECTED_CLASS = 'is-wine-offer-selected';

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/; SameSite=Lax';
  }

  function readState() {
    try {
      var raw = getCookie(COOKIE_NAME);
      if (!raw) return {};
      var parsed = JSON.parse(raw);
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (e) {
      return {};
    }
  }

  function writeState(state) {
    setCookie(COOKIE_NAME, JSON.stringify(state), COOKIE_DAYS);
  }

  function formatMoney(cents) {
    var value = (Number(cents) || 0) / 100;
    return (
      value.toLocaleString('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }) + ' €'
    );
  }

  function parseMoneyToCents(value) {
    if (typeof value === 'number' && !isNaN(value)) return Math.round(value);
    if (!value) return 0;
    var cleaned = String(value)
      .replace(/[^\d,.-]/g, '')
      .replace(/\./g, '')
      .replace(',', '.');
    var num = parseFloat(cleaned);
    return isNaN(num) ? 0 : Math.round(num * 100);
  }

  /* ------------------------------------------------------------------ */
  /* Collection selection mode                                          */
  /* ------------------------------------------------------------------ */

  function isSelectionMode(state) {
    return !!(state && state.selecting);
  }

  function getProductCard(el) {
    return el && el.closest ? el.closest('[data-wine-offer-product]') : null;
  }

  function extractWineFromCard(card) {
    if (!card) return null;

    var priceCents = parseInt(card.getAttribute('data-product-price'), 10);
    if (isNaN(priceCents)) {
      var priceEl = card.querySelector('.product-kachel_pricing .heading-style-h3:not(.is-compare)');
      priceCents = priceEl ? parseMoneyToCents(priceEl.textContent) : 0;
    }

    return {
      id: card.getAttribute('data-product-id') || '',
      variantId: card.getAttribute('data-variant-id') || '',
      title: card.getAttribute('data-product-title') || '',
      handle: card.getAttribute('data-product-handle') || '',
      url: card.getAttribute('data-product-url') || '',
      image: card.getAttribute('data-product-image') || '',
      price: priceCents,
      priceFormatted: formatMoney(priceCents),
    };
  }

  function highlightSelected(productId) {
    document.querySelectorAll('[data-wine-offer-product]').forEach(function (card) {
      var isSelected = productId && card.getAttribute('data-product-id') === String(productId);
      card.classList.toggle(SELECTED_CLASS, isSelected);
      card.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });
  }

  function updateFloatingBar(state, root) {
    if (!root) return;

    var promptEl = root.querySelector('[data-wine-offer-prompt]');
    var selectedEl = root.querySelector('[data-wine-offer-selected-label]');
    var returnBtn = root.querySelector('[data-wine-offer-return]');
    var wine = state.wine;

    if (wine && wine.title) {
      root.classList.add('has-selection');
      if (promptEl) promptEl.hidden = true;
      if (selectedEl) {
        selectedEl.hidden = false;
        selectedEl.textContent = wine.title;
      }
      if (returnBtn) {
        returnBtn.hidden = false;
        returnBtn.disabled = false;
      }
    } else {
      root.classList.remove('has-selection');
      if (promptEl) promptEl.hidden = false;
      if (selectedEl) {
        selectedEl.hidden = true;
        selectedEl.textContent = '';
      }
      if (returnBtn) {
        returnBtn.hidden = true;
        returnBtn.disabled = true;
      }
    }
  }

  function activateSelectionMode() {
    var state = readState();
    if (!isSelectionMode(state)) return;

    document.body.classList.add(BODY_CLASS);

    document.querySelectorAll('[data-wine-offer-product]').forEach(function (card) {
      card.setAttribute('role', 'button');
      card.setAttribute('tabindex', '0');
      card.setAttribute('aria-pressed', 'false');
    });

    var bar = document.querySelector('[data-wine-offer-bar]');
    if (bar) {
      bar.hidden = false;
      bar.setAttribute('aria-hidden', 'false');
      updateFloatingBar(state, bar);
    }

    if (state.wine && state.wine.id) {
      highlightSelected(state.wine.id);
    }

    var productGrid = document.getElementById('filter-product-grid');
    if (productGrid && typeof MutationObserver !== 'undefined') {
      var observer = new MutationObserver(function () {
        var current = readState();
        document.querySelectorAll('[data-wine-offer-product]').forEach(function (card) {
          card.setAttribute('role', 'button');
          card.setAttribute('tabindex', '0');
        });
        if (current.wine && current.wine.id) {
          highlightSelected(current.wine.id);
        }
      });
      observer.observe(productGrid, { childList: true, subtree: true });
    }

    document.addEventListener(
      'keydown',
      function (event) {
        if (!document.body.classList.contains(BODY_CLASS)) return;
        if (event.key !== 'Enter' && event.key !== ' ') return;
        var card = getProductCard(event.target);
        if (!card) return;
        event.preventDefault();
        card.click();
      },
      true
    );

    document.addEventListener(
      'click',
      function (event) {
        if (!document.body.classList.contains(BODY_CLASS)) return;

        var returnBtn = event.target.closest('[data-wine-offer-return]');
        if (returnBtn) {
          event.preventDefault();
          var current = readState();
          current.selecting = false;
          writeState(current);
          document.body.classList.remove(BODY_CLASS);
          if (bar) {
            bar.hidden = true;
            bar.setAttribute('aria-hidden', 'true');
          }
          var returnUrl = current.returnUrl || '/';
          window.location.href = returnUrl;
          return;
        }

        var cancelBtn = event.target.closest('[data-wine-offer-cancel]');
        if (cancelBtn) {
          event.preventDefault();
          var cancelState = readState();
          cancelState.selecting = false;
          writeState(cancelState);
          document.body.classList.remove(BODY_CLASS);
          if (bar) {
            bar.hidden = true;
            bar.setAttribute('aria-hidden', 'true');
          }
          window.location.href = cancelState.returnUrl || '/';
          return;
        }

        var blocked = event.target.closest(
          '.product_kachel .button, .product-kachel_cart-button-mobile, .product-kachel_like, .product_cta-item .w-button, .collection-promo__button, .iWishAddColl'
        );
        if (blocked && !event.target.closest('[data-wine-offer-bar]')) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }

        var card = getProductCard(event.target);
        if (!card) return;

        event.preventDefault();
        event.stopPropagation();

        var wine = extractWineFromCard(card);
        if (!wine || !wine.id) return;

        var next = readState();
        next.wine = wine;
        next.selecting = true;
        writeState(next);
        highlightSelected(wine.id);
        updateFloatingBar(next, bar);
      },
      true
    );
  }

  /* ------------------------------------------------------------------ */
  /* Form section                                                       */
  /* ------------------------------------------------------------------ */

  function initForm(root) {
    if (!root || root.dataset.wineOfferReady === 'true') return;
    root.dataset.wineOfferReady = 'true';

    var form = root.querySelector('[data-wine-offer-form]');
    if (!form) return;

    var selectBtn = root.querySelector('[data-wine-offer-select-btn]');
    var wineDisplay = root.querySelector('[data-wine-offer-wine-display]');
    var wineInput = root.querySelector('[data-wine-offer-wine-input]');
    var wineHidden = root.querySelector('[data-wine-offer-wine-json]');
    var quantityInput = root.querySelector('[data-wine-offer-quantity]');
    var priceEl = root.querySelector('[data-wine-offer-price]');
    var surchargeCents = parseInt(root.getAttribute('data-surcharge-cents') || '1000', 10);
    var minQty = parseInt(root.getAttribute('data-min-quantity') || '20', 10);
    var billingSameCheckbox = root.querySelector('[data-wine-offer-billing-same]');
    var billingFields = root.querySelector('[data-wine-offer-billing-fields]');
    var statusBox = root.querySelector('[data-wine-offer-status]');
    var fieldsBox = root.querySelector('[data-wine-offer-fields]');
    var submitBtn = root.querySelector('[data-wine-offer-submit]');
    var submitLabel = root.querySelector('[data-wine-offer-submit-label]');

    var messages = {
      success: root.getAttribute('data-success-message') || 'Anfrage erfolgreich gesendet.',
      error: root.getAttribute('data-error-message') || 'Beim Senden ist ein Fehler aufgetreten.',
      network: root.getAttribute('data-network-error-message') || 'Verbindungsfehler. Bitte erneut versuchen.',
      wineRequired: root.getAttribute('data-wine-required-message') || 'Bitte wähle zuerst einen Wein aus.',
      sending: root.getAttribute('data-sending-message') || 'Wird gesendet …',
    };

    function showStatus(text, type) {
      if (!statusBox) return;
      statusBox.hidden = false;
      statusBox.textContent = text;
      statusBox.className =
        'we-site-wine-offer-form__status we-site-wine-offer-form__status--' + type;
      scrollToStatus();
    }

    function scrollToStatus() {
      var target = statusBox || root;
      if (!target) return;
      window.requestAnimationFrame(function () {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    function hideStatus() {
      if (!statusBox) return;
      statusBox.hidden = true;
      statusBox.textContent = '';
      statusBox.className = 'we-site-wine-offer-form__status';
    }

    function getWineFromState() {
      var state = readState();
      return state.wine || null;
    }

    function applyWine(wine) {
      if (!wine) {
        if (wineDisplay) wineDisplay.textContent = wineDisplay.getAttribute('data-empty-label') || 'Noch kein Wein ausgewählt';
        if (wineInput) wineInput.value = '';
        if (wineHidden) wineHidden.value = '';
        root.classList.remove('has-wine');
        updatePrice();
        return;
      }

      root.classList.add('has-wine');
      if (wineDisplay) wineDisplay.textContent = wine.title || '';
      if (wineInput) wineInput.value = wine.title || '';
      if (wineHidden) wineHidden.value = JSON.stringify(wine);
      updatePrice();
    }

    function updatePrice() {
      if (!priceEl) return;
      var wine = getWineFromState();
      var qty = parseInt(quantityInput && quantityInput.value, 10) || 0;
      if (!wine || !wine.price || qty < 1) {
        priceEl.textContent = formatMoney(0);
        priceEl.setAttribute('data-price-cents', '0');
        return;
      }
      var total = (Number(wine.price) + surchargeCents) * qty;
      priceEl.textContent = formatMoney(total);
      priceEl.setAttribute('data-price-cents', String(total));
    }

    function syncBillingVisibility() {
      if (!billingFields || !billingSameCheckbox) return;
      var same = billingSameCheckbox.checked;
      billingFields.hidden = same;
      billingFields.setAttribute('aria-hidden', same ? 'true' : 'false');
      billingFields.querySelectorAll('input, select, textarea').forEach(function (field) {
        if (same) {
          field.removeAttribute('required');
          field.disabled = true;
        } else {
          field.disabled = false;
          if (field.dataset.required === 'true') field.setAttribute('required', 'required');
        }
      });
    }

    function collectAddress(prefix) {
      var fields = ['first_name', 'last_name', 'company', 'address1', 'address2', 'zip', 'city', 'country', 'phone'];
      var result = {};
      fields.forEach(function (field) {
        var el = form.querySelector('[name="' + prefix + '[' + field + ']"]');
        result[field] = el ? el.value.trim() : '';
      });
      return result;
    }

    function collectContact() {
      var fields = ['name', 'email'];
      var result = {};
      fields.forEach(function (field) {
        var el = form.querySelector('[name="contact[' + field + ']"]');
        result[field] = el ? el.value.trim() : '';
      });
      return result;
    }

    // Prefill from cookie
    applyWine(getWineFromState());

    // Clear selecting flag when back on form
    var stateOnLoad = readState();
    if (stateOnLoad.selecting) {
      stateOnLoad.selecting = false;
      writeState(stateOnLoad);
    }

    if (quantityInput) {
      if (minQty > 1 && (!quantityInput.value || parseInt(quantityInput.value, 10) < minQty)) {
        quantityInput.value = String(minQty);
      }
      quantityInput.setAttribute('min', String(minQty));
      quantityInput.addEventListener('input', updatePrice);
      quantityInput.addEventListener('change', function () {
        var val = parseInt(quantityInput.value, 10);
        if (isNaN(val) || val < minQty) quantityInput.value = String(minQty);
        updatePrice();
      });
    }

    if (billingSameCheckbox) {
      billingSameCheckbox.addEventListener('change', syncBillingVisibility);
      syncBillingVisibility();
    }

    if (selectBtn) {
      selectBtn.addEventListener('click', function (event) {
        event.preventDefault();
        var collectionUrl = selectBtn.getAttribute('href') || selectBtn.getAttribute('data-collection-url');
        if (!collectionUrl) return;

        var returnUrl = window.location.pathname + window.location.search + '#WeSiteSection-' + root.getAttribute('data-section-id');
        var next = readState();
        next.selecting = true;
        next.returnUrl = returnUrl;
        next.formSectionId = root.getAttribute('data-section-id');
        writeState(next);

        var separator = collectionUrl.indexOf('?') === -1 ? '?' : '&';
        window.location.href = collectionUrl + separator + 'wine_offer_select=1';
      });
    }

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      hideStatus();

      var wine = getWineFromState();
      if (!wine || !wine.id) {
        showStatus(messages.wineRequired, 'error');
        return;
      }

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      var apiUrl = form.getAttribute('data-api-url');
      if (!apiUrl) {
        showStatus(messages.error, 'error');
        return;
      }

      var qty = parseInt(quantityInput && quantityInput.value, 10) || 0;
      var shipping = collectAddress('shipping');
      var billing = billingSameCheckbox && billingSameCheckbox.checked ? shipping : collectAddress('billing');
      var contactPerson = collectContact();
      var offerPriceCents = (Number(wine.price) + surchargeCents) * qty;

      var payload = {
        wine: wine,
        quantity: qty,
        shipping_address: shipping,
        billing_address: billing,
        billing_same_as_shipping: !!(billingSameCheckbox && billingSameCheckbox.checked),
        contact_person: contactPerson,
        offer_price_cents: offerPriceCents,
        offer_price_formatted: formatMoney(offerPriceCents),
        surcharge_cents: surchargeCents,
        shop_domain: window.Shopify && window.Shopify.shop ? window.Shopify.shop : window.location.hostname,
      };

      var defaultLabel = submitLabel ? submitLabel.textContent : '';
      if (submitBtn) submitBtn.disabled = true;
      if (submitLabel) submitLabel.textContent = messages.sending;
      var submitted = false;

      try {
        var response = await fetch(apiUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload),
        });

        var result = null;
        try {
          result = await response.json();
        } catch (parseError) {
          showStatus(messages.error, 'error');
          return;
        }

        if (response.ok && result && (result.success === true || result.ok === true)) {
          submitted = true;
          var cleared = readState();
          delete cleared.wine;
          cleared.selecting = false;
          writeState(cleared);
          if (fieldsBox) {
            fieldsBox.hidden = true;
            fieldsBox.setAttribute('aria-hidden', 'true');
          }
          root.classList.add('is-submitted');
          showStatus((result && result.message) || messages.success, 'success');
          return;
        }

        showStatus((result && result.message) || messages.error, 'error');
      } catch (error) {
        showStatus(messages.network, 'error');
      } finally {
        if (!submitted) {
          if (submitBtn) submitBtn.disabled = false;
          if (submitLabel) submitLabel.textContent = defaultLabel;
        }
      }
    });
  }

  function boot() {
    if (document.documentElement.dataset.weWineOfferBooted === 'true') return;
    document.documentElement.dataset.weWineOfferBooted = 'true';

    // Enter selection mode via cookie or URL param
    var params = new URLSearchParams(window.location.search);
    if (params.get('wine_offer_select') === '1') {
      var state = readState();
      state.selecting = true;
      writeState(state);
      // Clean URL without reload
      params.delete('wine_offer_select');
      var clean = window.location.pathname + (params.toString() ? '?' + params.toString() : '') + window.location.hash;
      if (window.history && window.history.replaceState) {
        window.history.replaceState({}, '', clean);
      }
    }

    if (isSelectionMode(readState())) {
      activateSelectionMode();
    }

    document.querySelectorAll('[data-wine-offer-root]').forEach(initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
